import { resolveAsAttachment } from '@algbra/ui/resolvers'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { graphql, Link, StaticQuery } from 'gatsby'
import { filter, map } from 'rambdax'
import styles from './PageHorizontalNav.module.scss'

export type PageHorizontalNavProps = {
  theme?: 'default' | 'planetImpact'
  parent: string
}
export type SubLinkType = {
  title: string
  url: string
  parent: string
  isBanner?: boolean
  icon: GatsbyResolvedAsset
}
const QUERY_HEADER_NAVIGATION = graphql`
  query SubPageNavigationQuery {
    strapiGQL {
      navigationHeader {
        subLinks {
          title
          url
          parent
          icon {
            id
            url
            ext
            width
            height
            resolved {
              publicURL
            }
          }
          isBanner
        }
      }
    }
  }
`
export function PageHorizontalNav({
  parent,
  theme = 'default',
}: PageHorizontalNavProps) {
  // const isMobile = useMediaQuery(MEDIA_QUERY_MOBILE)
  // useEffect(() => {
  //   const element = document.querySelector('.horizontalNav [class*="active"]')
  //   if (element && isMobile) {
  //     element.scrollIntoView()
  //   }
  // }, [isMobile])

  if (!parent) {
    return null
  }

  return (
    <div
      className={classNames(
        'horizontalNav',
        styles.container,
        styles.theme,
        styles[`theme__${theme}`]
      )}
    >
      <StaticQuery
        query={QUERY_HEADER_NAVIGATION}
        render={({ strapiGQL: { navigationHeader } }) => {
          const filteredList = filter(
            link => link.parent === parent && !link.isBanner,
            navigationHeader.subLinks
          ) as SubLinkType[]

          return (
            <div className={styles.links}>
              <div className={styles.linksScrollable}>
                {map(
                  link => (
                    <Link
                      to={link.url}
                      activeClassName={styles.active}
                      key={link.url}
                    >
                      <img
                        src={resolveAsAttachment(link.icon)}
                        alt={link.title}
                      />
                      <span>{link.title}</span>
                    </Link>
                  ),
                  filteredList
                )}
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}
